import { useSelector } from "react-redux";

export enum Themes {
    LIGHT = "light",
    DARK = "dark",
    MM = "mm",
}

export const useThemeSelector = (): Themes => {
    return useSelector((store) => (store as any).app.theme);
};
